import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { debounceTime, Subject, takeUntil } from 'rxjs'

@Component({
  selector: 'efp-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent implements OnInit, OnDestroy {
  @Input() placeholderKey = 'Search'
  @Output() readonly searchTextChanged = new EventEmitter<string>()

  searchText = ''
  showClearButton = false
  private readonly destroy$ = new Subject<void>()

  public searchTextControl: FormControl<string | undefined> = new FormControl<string | undefined>(
    '',
    {
      nonNullable: true,
    }
  )

  constructor() {}

  ngOnInit(): void {
    this.emitSearchText('')

    this.searchTextControl.valueChanges
      .pipe(debounceTime(300), takeUntil(this.destroy$))
      .subscribe((value) => {
        this.showClearButton = !!(value && value.length > 0)
        this.emitSearchText(value ?? '')
      })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
  }

  clearSearch(): void {
    this.searchText = ''
    this.showClearButton = false
    this.emitSearchText('')
  }

  private emitSearchText(value: string): void {
    this.searchTextChanged.emit(value)
  }
}
